<!--
列表

使用说明：

<ListView
 :offset="'商品类型，可选small,normal'"
 :onInfinite=""
 :loading=""
 :hasMore=""
 :isEmpty=""
 >
 Slot Content
 </ListView>


-->

<template>
  <div class="scroll-loadmore"
       @touchstart="(onInfinite || infiniteLoading) ? onScroll($event) : undefined"
       @touchend="(onInfinite || infiniteLoading) ? onScroll($event) : undefined">
  <section class="inner">
      <slot></slot>
      <div class="load-more" v-if="!isEmpty">
        <slot name="loading" v-if="infiniteLoading">
          <p class="loading-text">加载中...</p>
        </slot>
        <slot name="load-done" v-if="!hasMore">
          <p class="loading-text">- 我是有底线的 -</p>
        </slot>
      </div>
    </section>
  </div>
</template>

<script>
  import $ from "jquery";

  let timer = null;
  export default {
    props: {
      offset: {
        type: Number,
        default: 30
      },
      onInfinite: {
        type: Function,
        default: undefined,
        require: false
      },
      hasMore: {
        type: Boolean,
        default: true
      },
      isEmpty: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        infiniteLoading: false,
        loadTimer: null
      };
    },
    methods: {
      infinite () {
        this.infiniteLoading = true;
        this.onInfinite(this.infiniteDone);
      },
      infiniteDone () {
        this.infiniteLoading = false;
      },
      onScroll () {
        if (this.infiniteLoading || !this.hasMore) {
          return;
        }
        clearTimeout(this.loadTimer);
        this.loadTimer = setTimeout(()=>{
          var bottom = Math.abs($(window).scrollTop() + $(window).height() - $(document).height());
          // console.log(`onLoad, bottom=${bottom}, offset=${this.offset}`);
          if (bottom < this.offset) {
            this.infinite();
          }
        }, 300)
      }
    },
    mounted() {
      // TODO 修复IE无法触发滚动加载
      clearInterval(timer)
      timer = setInterval(() => {
        (this.onInfinite || this.infiniteLoading) ? this.onScroll() : undefined
      }, 1000)
    },
    beforeDestroy() {
      clearInterval(timer)
    },
    components: {
    }
  };
</script>

<style lang="less" scoped>

  .scroll-loadmore .inner {
    display: block;
    transition-duration: 300ms;
  }

  .loading-text{
    font-size: 3.4vw;
    text-align: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/common/ListView.vue